import React from 'react';
/**
 * @ignore - internal component.
 */

var FormControlContext = React.createContext();
export default FormControlContext;